//import liraries
import React, { useEffect, useState } from "react";
import { Dimensions} from "react-native";

import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";


const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView =
  Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;


// define your styles
const useStyles = CreateResponsiveStyle(
  {
    mainContainer: {
      width: "98%",
      height: 435,
      backgroundColor: "#ffffff",
      borderRadius: 15,
      marginTop: 20,
      marginLeft: 20,
    },
    iconContainer: {
      marginTop: "2%",
      flexDirection: "row",
      paddingLeft: 20,
      paddingHorizontal: isSmallDevice || isTabView ? null : 50,
      marginLeft: isSmallDevice || isTabView ? null : 10,
      justifyContent: "space-between",
    },
    backIcon: {
      height: 19,
      width: 19,
      resizeMode: "center",
      opacity: 0.8,
    },
    backIconViewStyle: {
      flexDirection: "row",
    },
    textStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#999999",
      marginLeft: 10,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    subContainer: {
      flexDirection: "row",
    },
    poolAccountView: {
      flexDirection: "column",
      width: 300,
      marginVertical: 17,
      marginLeft: 50,
    },
    poolAccount: {
      marginLeft: 20,
    },
    containerBorder: {
      width: 320,
      height: 176,
      marginVertical: 20,
      borderRadius: 10,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#ccd0d5",
      marginLeft: 35,
      paddingHorizontal: 20,
    },
    autoRechargeTextStyle: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "bold",
      fontStyle: "normal",
      letterSpacing: 0.24,
      textAlign: "center",
      color: "#bd2d37",
      paddingRight: 10,
      paddingTop: 3,
    },
    cardContainer: {
      height: 84,
      marginVertical: 17,
      flexDirection: "row",
      justifyContent: "space-between",
    },
    innerContainer: {
      flexDirection: "column",
    },
    thirdContainer: {
      flexDirection: "column",
      alignSelf: "flex-start",
      marginLeft: 60,
      marginVertical: 17,
      width: 600,
    },

    textInputView: {
      flexDirection: "row",
      paddingTop: 20,
      marginLeft: 40,
    },
    minThresholdView: {
      flexDirection: "row",
      paddingTop: 40,
      marginLeft: 40,
    },
    mobilePoolChange: {
      flexDirection: "row",
      paddingTop: 40,
      display: "none",
      marginLeft: 60,
    },
    poolAccountView: {},

    poolAccountDetailView: {
      alignSelf: "flex-start",
      width: 300,
      height: 40,
    },

    selectTag: {
      flexDirection: "row",
      marginLeft: 50,
      width: 500,
      justifyContent: "space-between",
    },
    poolNumber: {
      width: 166.1,
      height: 28.8,
      backgroundColor: "#f8f8f8",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#c3c3c3",
      marginTop: 5,
      alignItems: "center",
      borderRadius: 5,
      paddingHorizontal: 10,
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 18,
      letterSpacing: 0.09,
      textAlign: "left",
      color: "#757575",
    },
    selectView: {
      width: 243.6,
      height: 39.4,
      borderRadius: 5,
      color: "#b6b7bf",
      fontWeight: "bold",
      borderWidth: 2,
      borderColor: "#dfdfdf",
      borderStyle: "solid",
      alignItems: "flex-start",
      paddingHorizontal: 10,
      justifyContent: "center",
    },
    selectText: {
      opacity: 0.4,
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 19.8,
      letterSpacing: 0.1,
      textAlign: "left",
      color: "#25243b",
    },
    perVehicle: {
      fontSize: 11,
      fontWeight: "500",
      alignSelf: "flex-end",
      color: "#757575",
      marginVertical: 10,
    },
    customButtonView: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
    overViewStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "600",
      fontStyle: "normal",
      lineHeight: 18,
      letterSpacing: 0.23,
      textAlign: "left",
      color: "#5f5f5f",
      paddingLeft: 40,
      paddingTop: 10,
    },
    buttonViewStyle: {
      width: 118,
      height: 31,
    },
    cardNUmberTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    poolAcTextStyle: {
      opacity: 0.6,
      fontFamily: "Inter",
      fontSize: 10,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 12,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    amountTextStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 18,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    bodyStyle: {
      flexDirection: "row",
      width: "100%",
    },
    poolAcNum: {
      marginHorizontal: 15,
    },
    labelTextStyle: {
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 17,
      letterSpacing: 0,
      textAlign: "left",
      color: "#66625f",
    },
    changeTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 14,
      letterSpacing: 0,
      textAlign: "left",
      color: "#cb0303",
    },
    changePoolViewStyle: {
      display: "flex",
    },
  },

  {
    [DEVICE_SIZES.SM]: {
      mainContainer: {
        width: "100%",
        height: 837,
      },
      iconContainer: {
        marginTop: "5%",
        flexDirection: "row",
        justifyContent: "flex-start",
      },
      subContainer: {
        flexDirection: "column",
      },
      thirdContainer: {
        flexDirection: "column",
        alignSelf: "flex-start",
        marginVertical: 17,
        marginRight: 20,
      },
      poolAccountView: {
        flexDirection: "column",
      },
      textInputView: {
        flexDirection: "column",
        paddingTop: 20,
        justifyContent: "space-between",
      },
      minThresholdView: {
        flexDirection: "column",
        paddingTop: 10,
        justifyContent: "space-between",
      },
      cardContainer: {
        marginLeft: 20,
      },
      innerContainer: {
        flexDirection: "column",
        marginright: 10,
      },
      poolAccount: {
        marginLeft: 5,
      },
      bodyStyle: {
        flexDirection: "column",
      },
      changePoolViewStyle: {
        display: "none",
      },
      mobilePoolChange: {
        display: "flex",
        paddingTop: 10,
        marginBottom: 20,
      },
      labelTextStyle: {
        paddingVertical: 3,
      },
    },

    [DEVICE_SIZES.MD]: {
      mainContainer: {
        width: "100%",
        height: 804.7,
      },
      bodyStyle: {
        flexDirection: "column",
      },
      iconContainer: {
        marginTop: "5%",
        flexDirection: "row",
        marginLeft: 30,
      },
      subContainer: {
        flexDirection: "column",
      },
      poolAccount: {
        marginLeft: 5,
      },
      containerBorder: {
        width: 371,
        height: 183,
        marginVertical: 20,
        borderRadius: 10,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#ccd0d5",
      },
      cardContainer: {
        marginLeft: 20,
      },
      innerContainer: {
        flexDirection: "column",
        marginright: 10,
      },
      changePoolViewStyle: {
        display: "none",
      },
      mobilePoolChange: {
        display: "flex",
      },
    },

    [DEVICE_SIZES.XS]: {
      mainContainer: {
        width: "100%",
        height: 837,
        marginLeft: 0
      },
      containerBorder: {
        width: 255,
        height: 159,
      },
      bodyStyle: {
        flexDirection: "column",
        marginLeft: -15,
        marginBottom: 20,
      },
      iconContainer: {
        marginTop: "7%",
        flexDirection: "row",
        justifyContent: "space-between",
        marginLeft: -7,
        marginRight: 10,
        alignItems: "center",
      },
      poolAccountView: {
        flexDirection: "column",
        marginLeft: 10,
      },
      thirdContainer: {
        flexDirection: "column",
        alignSelf: "flex-start",
        marginLeft: 20,
      },
      subContainer: {
        flexDirection: "column",
      },
      textInputView: {
        flexDirection: "column",
        paddingTop: 20,
        alignContent: "space-between",
      },
      minThresholdView: {
        flexDirection: "column",
        paddingTop: 10,
      },
      changePoolViewStyle: {
        display: "none",
      },
      mobilePoolChange: {
        display: "flex",
        paddingTop: 10,
        marginLeft: 45,
      },
      cardNUmberTextStyle: {
        fontSize: 11,
      },
      buttonViewStyle: {
        width: 99,
        height: 21,
      },
      labelTextStyle: {
        paddingVertical: 3,
      },
    },
  }
);


export default useStyles;
